import React from 'react';
import DebitNotePurchaseInvoice from '../../components/PurchaseInvoiceCreation/DebitNote/DebitNotePurchaseInvoice';

const DebitNotePurchaseInvoicePage: React.FC = () => {
  return (
    <div>
      <DebitNotePurchaseInvoice />
    </div>
  );
};

export default DebitNotePurchaseInvoicePage;
